<template>
    <ProgressSpinner v-if="!model"/>
    <Container class="pt-6" v-if="model">
        <div class="bg-surface-0 dark:bg-surface-900 -mx-8 px-8 -mt-6 pt-6 -mb-4 pb-4">
            <PageHeading>{{ model.name ?? $route.params.model }}</PageHeading>
        </div>

	    <div class="sticky top-0 bg-surface-0 dark:bg-surface-800 z-40 -mx-8 -px-8">
        <TabLayout :tabs="tabs" sticky/>
	    </div>

        <router-view
		        @on-save="$emit('on-save')"
		        @on-delete="$emit('on-delete')"
		        :model="model"
        ></router-view>
    </Container>
</template>

<script>
import PageHeading from "@/Components/PageHeading.vue";
import TabLayout from "@/Layouts/TabLayout.vue";
import { mapStores } from "pinia";
import { useDeviceModelsStore } from "@/stores/deviceModels.js";
import Container from "@/Components/Container.vue";


export default {
    name: "DeviceModelView",
    components: {Container, TabLayout, PageHeading},
    data() {
        return {
            model: undefined,
        }
    },
    emits: [
        'on-save',
		    'on-delete',
    ],
    watch: {
        '$route.params.model': {
            async handler(newValue, oldValue) {
                if(newValue){
                    this.model = undefined;
                    if(this.$route.params.model === 'NEW'){
                        this.model = {};
                    } else {
                        this.model = await this.deviceModelsStore.showDeviceModel( this.$route.params.model);
                    }
                } else {
                    this.model = undefined;
                }
            },
            immediate: true,
        }
    },
    computed: {
        ...mapStores(useDeviceModelsStore),
        tabs() {
            return [
                {
                    label: this.$t('common.summary'),
                    current: this.$route.name === 'admin.devices.models.model',
                    to: {name: 'admin.devices.models.model', params: this.$route.params}
                },
            ]
        }
    },
}
</script>
